/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { object } from 'prop-types';

import ProductBlogSlider from './Partials/ProductBlogSlider';
import ProductTitle from '../ProductTitle';
import ProductDivider from '../ProductDivider';

// Data
import { BlogData, BlogSliderSetting } from './Partials/BlogData';

const styles = () => ({
    blogWrapper: {
        textAlign: 'center',
    },
});

const ProductBlogSection = ({ classes }) => (
    <div className={classes.blogWrapper}>
        <ProductTitle title="RELATED BLOG POSTS" />
        <ProductBlogSlider data={BlogData()} setting={BlogSliderSetting()} />
        <ProductDivider />
    </div>
);

ProductBlogSection.propTypes = {
    classes: object.isRequired,
};

export default withStyles(styles)(ProductBlogSection);
